import { WL } from '@cyberint/common-utils';

export const { MAIN_BRAND_NAME } = WL;

export const DEMO_USER_TEAM = 'argos-demo';
export const RETAIL_USER_TEAM = 'retail';
export const SINGTEL_MSSP_TEAM = 'singtel-mssp';
export const SOFTBANK_TEAM = 'softbank';
export const TOYOTA_TEAM = 'toyota';
export const NOVARTIS_TEAM = 'novartis';
export const BARCLAYS_TEAM = 'barclays';
export const NON_CYBERINT_USER = 'non-cyberint-team';
